import { createStore } from "vuex";
import { auth } from "./auth.module";
import { register } from "./register.module";
import { company } from "./company.module";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { expenses } from "./expenses.module";
import { item } from "./item.module";
import { quotation } from "./quotation.module";
import { setting } from "./setting.module";
import { invoice } from "./invoice.module";
import { client } from "./client.module";

const secret_key = "smoothbalanceAES123";

const store = createStore({
  getters: {
    getSKey: () => {
      return secret_key;
    },
  },
  modules: {
    auth,
    register,
    company,
    expenses,
    item,
    quotation,
    setting,
    invoice,
    client,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => {
          let original_data = null;
          try {
            const storedValue = window.localStorage.getItem(key);
            if (storedValue) {
              var bytes = CryptoJS.AES.decrypt(storedValue, secret_key);
              original_data = bytes.toString(CryptoJS.enc.Utf8);
            }
          } catch (error) {
            console.log(error);
          }
          return original_data;
        },
        setItem: (key, value) => {
          const encrypted_value = CryptoJS.AES.encrypt(value.toString(), secret_key).toString();
          window.localStorage.setItem(key, encrypted_value);
        },
        removeItem: (key) => {
          window.localStorage.removeItem(key);
        },
      },
    }),
  ],
});

export default store;
